var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3126 14.5167L11.0646 10.2687C12.0854 9.04322 12.5945 7.47133 12.4858 5.88005C12.3772 4.28878 11.6593 2.80064 10.4814 1.72521C9.30354 0.64978 7.75639 0.0698616 6.16182 0.106093C4.56726 0.142325 3.04804 0.791917 1.92022 1.91974C0.792405 3.04756 0.142813 4.56677 0.106581 6.16133C0.0703499 7.7559 0.650269 9.30305 1.7257 10.4809C2.80113 11.6588 4.28927 12.3767 5.88054 12.4854C7.47182 12.594 9.04371 12.0849 10.2692 11.0641L14.5172 15.3121L15.3126 14.5167ZM1.2501 6.31211C1.2501 5.31084 1.54701 4.33206 2.10328 3.49953C2.65956 2.66701 3.45021 2.01814 4.37526 1.63497C5.30031 1.2518 6.31821 1.15154 7.30024 1.34688C8.28227 1.54222 9.18432 2.02438 9.89232 2.73238C10.6003 3.44038 11.0825 4.34243 11.2778 5.32446C11.4732 6.30649 11.3729 7.32439 10.9897 8.24944C10.6066 9.17449 9.95769 9.96515 9.12517 10.5214C8.29265 11.0777 7.31386 11.3746 6.3126 11.3746C4.97039 11.3731 3.68359 10.8393 2.73451 9.89019C1.78543 8.94111 1.25158 7.65431 1.2501 6.31211Z",
    fill: "#A0ACB8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.16715a716497b986391cf8c24330787a.svg";
export { ForwardRef as ReactComponent };